<template>
  <Logs />
</template>

<script>
import Logs from '@/components/admin/logs/ActivityLogs.vue'

export default {
  name: 'AdministrationActivityLogs',
  components: { Logs }
}
</script>

<style scoped>

</style>
